// Count of each character type in play, shown in the middle of the circle: the official
// distribution for the non-Traveler player count. Base table only, so a Baron's extra Outsiders
// aren't reflected. Players see it once roles are out; Storytellers from the start.

import { Flame, Ghost, Swords, Users } from "lucide-react";
import { DISTRIBUTION } from "@cc/shared";
import type { GameView, Team } from "@cc/shared";
import { teamLabel } from "../../lib/ui.js";

// Brighter than the seat-token team colours: the Demon's token red is nearly black against the
// backdrop, which is fine for a filled circle and unreadable as text.
const ROWS: { team: Team; index: number; Icon: typeof Users; color: string }[] = [
  { team: "townsfolk", index: 0, Icon: Users, color: "#6a9be0" },
  { team: "outsider", index: 1, Icon: Ghost, color: "#4fc0c0" },
  { team: "minion", index: 2, Icon: Swords, color: "#e0684f" },
  { team: "demon", index: 3, Icon: Flame, color: "#e03c3c" },
];

export function TeamCounts({ view }: { view: GameView }) {
  if (!view.you.isStoryteller && !view.rolesRevealed) return null;
  const players = view.seats.filter((s) => !s.isTraveler).length;
  const dist = DISTRIBUTION[players];
  if (!dist) return null;

  return (
    <div className="mt-2 flex items-center justify-center gap-3" aria-label="Characters in play by type">
      {ROWS.map(({ team, index, Icon, color }) => (
        <span
          key={team}
          title={`${dist[index]} ${teamLabel(team)}`}
          className="flex items-center gap-1 text-lg font-semibold tabular-nums"
          style={{ color }}
        >
          <Icon className="size-5" />
          {dist[index]}
        </span>
      ))}
    </div>
  );
}
